module.exports = __webpack_public_path__ + "assets/img/eu-founded.png";